import { render, staticRenderFns } from "./compensateRecord.vue?vue&type=template&id=7bbd3165&scoped=true&"
import script from "./compensateRecord.vue?vue&type=script&lang=js&"
export * from "./compensateRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbd3165",
  null
  
)

export default component.exports